import { applyMiddleware, createStore, compose, combineReducers } from 'redux';
import thunkMiddleware from 'redux-thunk';

import { userReducer } from '../reducers';
import { signInFormReducer } from '../../SignInForm';

const initialStoreState = {
    user: null,
};

export function createReduxStore(enhancers = []) {
    return createStore(
        combineReducers({
            user: userReducer,
            signInForm: signInFormReducer,
        }),
        initialStoreState,
        compose(
            applyMiddleware(thunkMiddleware),
            ...enhancers
        ),
    );
}
